export const availableScopeGroups = {
    admin: [
        { scopes: ['read:creditors', 'write:creditors'] },
        { scopes: ['read:ultimate-creditors', 'write:ultimate-creditors'] },
        { scopes: ['read:contacts', 'write:contacts'] },
        { scopes: ['read:users', 'write:users'] },
        { scopes: ['read:cases', 'write:cases'] },
        { scopes: ['read:properties', 'write:properties'] },
        { scopes: ['read:customers', 'write:customers'] },
        { scopes: ['write:customers.delete'] },
        { scopes: ['read:case-vouchers', 'write:case-vouchers'] },
        { scopes: ['read:voucher-types', 'write:voucher-types'] },
        { scopes: ['read:end-reasons', 'write:end-reasons'] },
        { scopes: ['read:case-groups', 'write:case-groups'] },
        { scopes: ['read:files', 'write:files'] },
        { scopes: ['read:updates', 'write:updates'] },
        { scopes: ['write:interactions.create'] },
        { scopes: ['read:cosmo', 'write:cosmo'] },
        { scopes: ['read:billings'] },
        { scopes: ['read:transaction-accounts', 'write:transaction-accounts'] },
        { scopes: ['write:collection-engine.vouchers'] },
        { scopes: ['read:payment-plans'] },
        { scopes: ['read:webhooks', 'write:webhooks'] },
        {
            scopes: [
                'read:insights.cases',
                'read:insights.creditors',
                'read:insights.satisfactions',
                'read:insights.debtor-vouchers', //Deprecated. Replaced by case-vouchers
                'read:insights.case-vouchers',
                'read:insights.billing-vouchers',
                'read:insights.users',
                'read:insights.updates',
                'read:insights.update-types',
                'read:insights.workflows',
                'read:insights.workflow-tasks',
                'read:insights.case-statuses',
                'read:insights.interactions',
                'read:insights.documents',
                'read:insights.payment-plans',
                'read:insights.payment-plan-entries',
                'read:insights.customers',
                'read:insights.users-on-customers',
                'read:insights.properties',
            ],
        },
    ],
    client: [
        {
            scopes: ['read:cases', 'write:cases'],
        },
        {
            scopes: ['write:files'],
        },
        {
            scopes: ['write:documents'],
        },
        {
            scopes: ['read:billings'],
        },
        {
            scopes: ['read:ultimate-creditors'],
        },
        {
            scopes: ['read:customers', 'write:customers'],
        },
        {
            scopes: ['write:interactions.create'],
        },
        {
            scopes: ['read:case-vouchers', 'write:case-vouchers'],
        },
        {
            scopes: ['read:voucher-types'],
        },
        {
            scopes: ['read:webhooks', 'write:webhooks'],
        },
        {
            scopes: [
                'read:insights.cases',
                'read:insights.satisfactions',
                'read:insights.case-vouchers',
                'read:insights.billing-vouchers',
                'read:insights.case-statuses',
                'read:insights.payment-plans',
                'read:insights.payment-plan-entries',
                'read:insights.customers',
                'read:insights.users-on-customers',
                'read:insights.updates',
                'read:insights.update-types',
                'read:insights.interactions',
            ],
        },
    ],
};
export const availableScopes = Object.entries(availableScopeGroups).reduce((acc, [role, groups]) => {
    acc[role] = groups.reduce((azz, group) => [...azz, ...group.scopes], []);
    return acc;
}, {});
//# sourceMappingURL=index.js.map